import ReactDOM from 'react-dom/client';
import { v2Component } from '../../..';
import { TenantContext } from '../../../context/tenant-context';
import { LocationSelect } from './location-select';

export function initLocationSelect() {
  document.getElementsByName('location-select-dropdown').forEach((element) => {
    if (element.getAttribute('initalized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const root = ReactDOM.createRoot(element);
      const setRootAttributes = (o: any) => {
        Object.keys(o).forEach((k) => {
          element.setAttribute(k, o[k]);
        });
      };

      const bootstrap = (mutations: MutationRecord[]) => {
        if (mutations.length === 0 || mutations.find((r) => r.attributeName === 'data-location-id')) {
          const { tenant, contextPath, ...props } = Object.assign({}, element.dataset) as any;
          root.render(
            v2Component(
              <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
                <LocationSelect {...props} setRootAttributes={setRootAttributes} />
              </TenantContext.Provider>,
            ),
          );
          const event = new CustomEvent('change');
          element.dispatchEvent(event);
        }
      };

      const observer = new MutationObserver(bootstrap);
      observer.observe(element, { attributes: true });
      bootstrap([]);
    }
  });
}
